import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderStyled = styled('div')`
  ${({ theme }) => theme.breakpoints.down('xl')} {
    position: relative;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    position: static;
  }
`;

interface HeroStyledProps {
  ff_ren1520_compliancewelcome_newdesign?: boolean;
}
export const HeroStyled = styled(Grid)<HeroStyledProps>`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0 55px;
  gap: 32px;

  > div:first-of-type {
    h2,
    h3 {
      font-family: 'Ivar Display';
      letter-spacing: -2px;

      ${({ theme }) => theme.breakpoints.down('xl')} {
        letter-spacing: -0.8px;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('xl')} {
    padding-bottom: 22px;
  }
  ${({ theme }) => theme.breakpoints.down('lg')} {
    padding: 75px 0 22px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 48px 32px 38px;
    gap: 24px;
    align-items: flex-start;
  }
`;

export const CardsContainerStyled = styled(Grid)`
  justify-content: center;
  overflow: hidden;

  gap: 48px;
  padding: 5px 48px 0px;

  ${({ theme }) => theme.breakpoints.down('xl')} {
    padding-top: 38px;
    padding-bottom: 25px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 25px 32px 0;
  }
`;
